import React, {Component} from 'react'
import $ from 'jquery'

const Jeyu = {
  Photo: {
    width: 55,
    height: 38,
    position: 'absolute',
    left: 10
  }
}

class ABCNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: []
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=the-next-web&sortBy=latest&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>ABC News (AU)</h1>
        { news }
        </section>
    )
  }
}

class AIJazzraEnglish extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=al-jazeera-english&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Al Jazeera English</h1>
        { news }
        </section>
    )
  }
}

class ArsTechnica extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=ars-technica&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Ars Technica</h1>
        { news }
        </section>
    )
  }
}

class BBCNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=bbc-news&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>BBC News</h1>
        { news }
        </section>
    )
  }
}
class BBCSport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=bbc-sport&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>BBC Sport</h1>
        { news }
        </section>
    )
  }
}
class Bild extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=bild&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
       </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Bild</h1>
        { news }
        </section>
    )
  }
}
class Bloomberg extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=bloomberg&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Bloomberg</h1>
        { news }
        </section>
    )
  }
}
class BusinessInsider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=business-insider&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Business Insider</h1>
        { news }
        </section>
    )
  }
}
class CNBC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=cnbc&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>CNBC</h1>
        { news }
        </section>
    )
  }
}
class CNN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=cnn&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>CNN</h1>
        { news }
        </section>
    )
  }
}
class Focus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=focus&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Focus</h1>
        { news }
        </section>
    )
  }
}
class GoogleNews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=google-news&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Google News</h1>
        { news }
        </section>
    )
  }
}
class Time extends Component {
  constructor(props) {
    super(props);
    this.state = {
      new: [],
      key: ''
    }
  }
  componentDidMount() {
    this.NewsList()
  }
  NewsList() {
    return $.getJSON('https://newsapi.org/v1/articles?source=time&sortBy=top&apiKey=d6004c1a873f4fb58bbd14de7290af46')
      .then((data) => {
        this.setState({ new: data.articles });
      });
  }
  render() {
    const news = this.state.new.map((item, i) => {
      return(
        <article key={i}>
         <a href={item.url} target="_blank">
          <img src={item.urlToImage} alt={item.title} style={Jeyu.Photo}/>
          <h1>
          {item.title}
          </h1>
          <p>
           {item.description}
          </p>
         </a>
        </article>
      )
    });
    return(
        <section className="panel-list" key={news.toString()}>
        <h1>Time</h1>
        { news }
        </section>
    )
  }
}


export default class NewsList extends Component {
  render() {
    return(

     <div className="masonry">
      <div className="item">
        <ABCNews />
      </div>
      <div className="item">
        <AIJazzraEnglish />
      </div>
      <div className="item">
        <ArsTechnica />
      </div>
      <div className="item">
        <BBCNews />
      </div>
      <div className="item">
        <BBCSport />
      </div>
      <div className="item">
        <Bild />
      </div>
      <div className="item">
        <Bloomberg />
      </div>
      <div className="item">
        <BusinessInsider />
      </div>
      <div className="item">
        <CNBC />
      </div>
      <div className="item">
        <CNN />
      </div>
      <div className="item">
        <Focus />
      </div>
      <div className="item">
        <GoogleNews />
      </div>
      <div className="item">
        <Time />
      </div>
     </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/View/NewsList.js